import TEXTS from '../controller/TextVariables';
import { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { sviThemes } from '../model/SVIThemeModel';
import DropDown from './Dropdown';

const ThemeSelectView = () => {
    const { setSelectedTheme, theme, tab, year } = useContext(InterfaceContext);
    const { label, tooltip: tooltipMap, tooltiptable } = TEXTS.controls.svi_select;

    const tooltip = tab.slug == 'map' ? tooltipMap : tooltiptable;

    const adjustThemeLabel = (theme) => {
        var themeObj = { ...theme };
        themeObj.label = year.label + '' === '2020' || year.label + '' === '2022' ? theme.label2020 : theme.labelPast;
        return themeObj;
    };
    const adjustbyYear = sviThemes.map((theme) => {
        return adjustThemeLabel(theme);
    });
    const onChangeTheme = (val) => {
        setSelectedTheme(val);
    };
    return (
        <>
            <div id="svi-select" className="svi field wide">
                <DropDown selected={theme} label={label} list={adjustbyYear} tooltip={tooltip} tooltipPlace="bottom" onChange={onChangeTheme} />
            </div>
        </>
    );
};
export default ThemeSelectView;
